jQuery(function ($) {
  var scrollContainerSwiper;
  $.ScrollContainerSwiper = function () {
  };

  $.ScrollContainerSwiper.prototype = {

    /**
     * Defines the selection of all sliders on the current view
     * @static
     */
    scrollContainer: $('.scroll-container-swiper'),

    /**
     * @method init
     * @desc initialize this module depending on the client
     */
    init: function () {
      this.scrollContainer.each(function () {
        var swiper;
        var swiperOptions = {
          direction: 'vertical',
          slidesPerView: 'auto',
          freeMode: true,
          preventClicks: false,
          scrollbar: {
            el: '.swiper-scrollbar'
          },
          mousewheel: true
        };

        swiper = new Swiper(this, swiperOptions);
        swiper.init();

        // Add a reverse reference to the DOM object
        $(this).data('ScrollContainerSwiper', swiper);
      });
    }
  };

  scrollContainerSwiper = new $.ScrollContainerSwiper();
  scrollContainerSwiper.init();
});
